import styled from 'styled-components';

import colours from 'theme/atoms/colours';
import * as Buttons from 'theme/components/Buttons.style';
import * as Text from 'theme/components/Text.style';

export const Container = styled('div')<{ $hasPriority: boolean }>`
  display: flex;
  flex-direction: ${({ $hasPriority }) => ($hasPriority ? 'column' : 'row')};
  align-items: ${({ $hasPriority }) => ($hasPriority ? 'stretch' : 'center')};
  gap: ${({ $hasPriority }) => ($hasPriority ? '10px' : '5px')};
  width: 100%;
  background-color: ${colours.shade[0]};
  border-radius: ${({ $hasPriority }) => ($hasPriority ? '35px' : '40px')};
  padding: 10px;
  box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.03),
    0 20px 80px -15px rgba(0, 29, 37, 0.1);
  box-sizing: border-box;
`;

export const PriorityPromptWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  width: 100%;
  box-sizing: border-box;
`;

export const PriorityPrompt = styled(Text.P2)`
  flex: 1 1 0;
  min-width: 0;
  color: ${colours.neutral[900]};
  word-break: break-word;
`;

export const ActionsRow = styled('div')`
  display: flex;
  gap: 5px;
  width: 100%;
  align-items: center;
`;

export const AddUpdateButton = styled(Buttons.SecondaryDark)`
  flex: 1 1 0;
  min-width: 0;
`;

export const ResolveButton = styled(Buttons.SecondaryLight)`
  flex: 1 1 0;
  min-width: 0;
`;
